module.exports = __webpack_public_path__ + "static/CircularPro-Bold.60baac55.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Bold.woff2
// module id = 720
// module chunks = 168707334958949